export default __webpack_public_path__ + "static/media/3.5a2469db.jpg";